export default __webpack_public_path__ + "img/busan_rock-bb06c1d628c8fdd30e05292f8bf4d836.png";